import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function AudienceSection() {
  const isFor = ["Mujeres que sienten que 'todo les cae mal' y se hinchan después de comer.", 'Personas que han subido de peso repentinamente debido al estrés o cambios hormonales.', 'Mujeres profesionales que necesitan recuperar su claridad mental y energía de inmediato.', "Cualquier persona que necesite un 'reset' rápido antes de un evento o compromiso importante."];
  const notFor = ['Personas que buscan una píldora mágica sin cambiar lo que ponen en su plato por 3 días.', 'Atletas de alto rendimiento en pleno entrenamiento de competición.', 'Personas que no están dispuestas a dejar el café o los lácteos por solo 72 horas.'];
  return <section className="bg-cream py-20 px-4" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-16">
          <FadeIn data-id="element-17">
            <div className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-sage h-full" data-id="element-18">
              <h3 className="text-2xl font-bold text-brown-dark mb-6 flex items-center" data-id="element-19">
                <CheckIcon className="w-8 h-8 text-sage mr-3" data-id="element-20" />
                Esto ES para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-21">
                {isFor.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-22">
                    <CheckIcon className="w-5 h-5 text-sage flex-shrink-0 mt-1" data-id="element-23" />
                    <span className="text-brown-body" data-id="element-24">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-25">
            <div className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-muted-red h-full" data-id="element-26">
              <h3 className="text-2xl font-bold text-brown-dark mb-6 flex items-center" data-id="element-27">
                <XIcon className="w-8 h-8 text-muted-red mr-3" data-id="element-28" />
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-29">
                {notFor.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-30">
                    <XIcon className="w-5 h-5 text-muted-red flex-shrink-0 mt-1" data-id="element-31" />
                    <span className="text-brown-body" data-id="element-32">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}